import React from 'react';
import LinkButton from 'components/LinkButton';
import BasicCheckbox from 'components/BasicCheckbox';

import './styles.css';

const ProfileItemReference = props => {
  const { data } = props;
  const {
    Active,
    Deleted,
    ReferenceID,
    ReferrerCompany,
    ReferrerEmail,
    ReferrerName,
    ReferrerPhone,
    ReferrerTitle,
  } = data;

  const { editable = false, onShowToggle, onDelete } = props;

  const showToFirms = !!Number(Active);
  const removed = !!Number(Deleted);

  const handleShowReference = () => {
    onShowToggle(ReferenceID, !showToFirms);
  };

  const handleDeleteReference = () => {
    onDelete(ReferenceID, !removed);
  };

  return (
    <div className="profile-item-reference">
      <div className="profile-item-reference__content">
        {editable && (
          <div className="profile-item-reference__controls profile-item-reference__controls--flex">
            <div className="profile-item-reference__control">
              <BasicCheckbox
                value={showToFirms}
                singleRow
                checked={showToFirms}
                title="Show"
                name="ApplicationDeadline"
                controlFunc={handleShowReference}
                labelStyles={{
                  fontFamily: 'Noto Sans, sans-serif',
                  fontSize: '0.9286rem',
                }}
              />
            </div>

            <div className="profile-item-reference__control">
              <BasicCheckbox
                value={removed}
                singleRow
                checked={removed}
                title="Delete"
                name="ApplicationDeadline"
                controlFunc={handleDeleteReference}
                labelStyles={{
                  fontFamily: 'Noto Sans, sans-serif',
                  fontSize: '0.9286rem',
                }}
              />
            </div>
          </div>
        )}

        <h5 className="profile-item-reference__name">{ReferrerName}</h5>
        <span className="profile-item-reference__link">
          <span>{ReferrerCompany}</span>
        </span>
        <span className="profile-item-reference__field">{ReferrerTitle}</span>
        <span className="profile-item-reference__link">
          <LinkButton
            text={ReferrerEmail}
            link={`mailto:${ReferrerEmail}`}
            btnFontFamily="Noto Sans, sans-serif"
            btnFontWeight="400"
            btnFontSize="0.9286rem"
          />
        </span>

        <span className="profile-item-reference__phone">{ReferrerPhone}</span>
      </div>
    </div>
  );
};

export default ProfileItemReference;
